(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funk-blog"] && !Shopify.designMode) return;
  try {
    
  /* Funk Journal — client-side sort.
     Shopify doesn't expose query params to Liquid for blog templates,
     so the sort dropdown is JS-driven. The server still renders cards
     in default order (latest first); on load, this script reads
     ?sort= from the URL, sorts the visible cards in place, hides the
     featured spot (since it only makes sense for latest-first view),
     and syncs the dropdown to match. On change, it navigates to the
     same URL with the sort param updated. */
  (function () {
    function init() {
      const section = document.querySelector('.funk-blog');
      const grid = document.querySelector('[data-funk-blog-grid]');
      const select = document.querySelector('[data-funk-blog-sort]');
      if (!section || !grid || !select) return;

      const params = new URLSearchParams(window.location.search);
      const sortKey = params.get('sort') || '';

      if (sortKey) {
        select.value = sortKey;
        applySort(grid, sortKey);
        section.dataset.funkSortActive = sortKey;
      }

      select.addEventListener('change', function () {
        const url = new URL(window.location.href);
        if (select.value) {
          url.searchParams.set('sort', select.value);
        } else {
          url.searchParams.delete('sort');
        }
        // Drop any current ?page= so the new sort starts at page 1.
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    function applySort(grid, key) {
      const cards = Array.from(grid.querySelectorAll('[data-funk-blog-card]'));
      cards.sort(function (a, b) {
        const at = (a.dataset.title || '').toLowerCase();
        const bt = (b.dataset.title || '').toLowerCase();
        const ad = parseInt(a.dataset.date || '0', 10);
        const bd = parseInt(b.dataset.date || '0', 10);
        switch (key) {
          case 'oldest': return ad - bd;
          case 'a-z':    return at.localeCompare(bt);
          case 'z-a':    return bt.localeCompare(at);
          default:       return bd - ad;
        }
      });
      const frag = document.createDocumentFragment();
      cards.forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-collection-grid"] && !Shopify.designMode) return;
  try {
    
  /* Submit the filter form on any input change.

     The native GET form rebuilds
     the URL from form inputs and navigates — Shopify then renders the
     collection with the new sort + availability applied. Reliable
     because it's just plain HTML form submission, no custom-element
     dependencies. The cost is a full page reload per filter change;
     the gain is "it always works" — which is what quality means here.

     Subtle visual cue: while the navigation is in flight, the grid
     fades to 0.45 opacity (data-funk-coll-loading="true" on the
     section root). The CSS handles the actual fade. */
  (function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    document.querySelectorAll('[data-funk-coll-facets]').forEach(function (form) {
      var inputs = form.querySelectorAll('select, input[type="checkbox"]');
      var section = form.closest('.funk-coll-grid');

      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (section) {
            section.setAttribute('data-funk-coll-loading', 'true');
          }
          // Defer submit one tick so the loading attribute repaints
          // before navigation begins — gives the fade a chance to start.
          window.requestAnimationFrame(function () {
            form.submit();
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-marquee"] && !Shopify.designMode) return;
  try {
    
  class FunkMarquee extends HTMLElement {
    constructor() {
      super();
      this.items = Array.from(this.querySelectorAll('.funk-marquee__item'));
      this.interval = parseInt(this.dataset.interval || '5000', 10);
      this.current = 0;
      this.paused = false;
      this.timer = null;

      if (this.items.length <= 1) return;

      if (this.classList.contains('funk-marquee--pause')) {
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());
      }

      // Defer the first rotation so users can read the first phrase
      // for the full interval, not a clipped opening tick.
      this.start();
    }

    start() {
      this.timer = setInterval(() => this.next(), this.interval);
    }

    pause() {
      this.paused = true;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resume() {
      if (!this.paused) return;
      this.paused = false;
      if (!this.timer) this.start();
    }

    next() {
      const previous = this.items[this.current];
      this.current = (this.current + 1) % this.items.length;
      const upcoming = this.items[this.current];
      // Swap classes in the same frame so opacity transitions
      // run simultaneously — a true cross-fade.
      previous.classList.remove('is-visible');
      upcoming.classList.add('is-visible');
    }
  }

  customElements.define('funk-marquee', FunkMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-newsletter"] && !Shopify.designMode) return;
  try {
    
  /* Progressive enhancement: sequential fade-up on scroll into view. */
  (function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    const sections = document.querySelectorAll('.funk-newsletter');
    if (!('IntersectionObserver' in window) || sections.length === 0) return;

    document.documentElement.classList.add('js-funk-newsletter-anim');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-product-features"] && !Shopify.designMode) return;
  try {
    
  /* Entrance animation only. Single IntersectionObserver per section.
     No scroll listeners, no polling, no layout thrashing. */
  (function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    const sections = document.querySelectorAll('.funk-pfeatures');
    if (!('IntersectionObserver' in window) || sections.length === 0) return;

    document.documentElement.classList.add('js-funk-pfeatures-anim');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-product-specs"] && !Shopify.designMode) return;
  try {
    
  /* Single IntersectionObserver for entrance animation. Same cheap
     pattern as every other Funk section. No scroll listeners. */
  (function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    const sections = document.querySelectorAll('.funk-pspecs');
    if (!('IntersectionObserver' in window) || sections.length === 0) return;

    document.documentElement.classList.add('js-funk-pspecs-anim');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-product-spread"] && !Shopify.designMode) return;
  try {
    
  /* Photo gallery: click a thumb to swap the hero image. Cheap, no JS
     framework, no extra dependencies. The variant-selects element from
     Dawn handles its own image-swap-on-variant-change; this script only
     covers manual thumb clicks. */
  (function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    document.querySelectorAll('.funk-product').forEach((section) => {
      const heroMedia = section.querySelector('[data-funk-hero-media]');
      const thumbs = section.querySelectorAll('[data-funk-thumb]');
      const counter = section.querySelector('[data-funk-counter]');
      if (!heroMedia || thumbs.length < 2) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const thumbImg = thumb.querySelector('img');
          if (!thumbImg) return;

          // Build a high-res src by swapping the &width= query param.
          const srcLarge = thumbImg.src.replace(/(\?|&)width=\d+/, '$1width=1500');

          const heroImg = heroMedia.querySelector('img');
          if (heroImg) {
            heroImg.src = srcLarge;
            heroImg.srcset = '';
            heroImg.alt = thumbImg.alt || '';
          }

          thumbs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-current', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-current', 'true');

          // Tick the specimen counter forward — "01" → "02" etc.
          if (counter) {
            const idx = parseInt(thumb.dataset.mediaIndex || '0', 10);
            if (idx > 0) counter.textContent = String(idx).padStart(2, '0');
          }
        });
      });
    });

    document.querySelectorAll('[data-funk-product-sticky]').forEach((bar) => {
      const productInfo = bar.closest('product-info');
      if (!productInfo) return;
      const submitBtn = productInfo.querySelector('[id^="ProductSubmitButton-"]');
      const stickyAdd = bar.querySelector('[data-funk-sticky-add]');
      const mainPrice = productInfo.querySelector('[id^="price-"]');
      const stickyPrice = bar.querySelector('[id^="price-sticky-"]');
      if (!submitBtn || !stickyAdd) return;

      const syncStickyState = () => {
        const submitLabel = submitBtn.querySelector('.funk-product__add-btn-label');
        const stickyLabel = stickyAdd.querySelector('span');
        stickyAdd.disabled = submitBtn.disabled;
        if (submitLabel && stickyLabel) stickyLabel.textContent = submitLabel.textContent.trim();
        if (mainPrice && stickyPrice) stickyPrice.textContent = mainPrice.textContent.trim();
      };

      syncStickyState();
      new MutationObserver(syncStickyState).observe(submitBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });
      if (mainPrice && stickyPrice) {
        new MutationObserver(syncStickyState).observe(mainPrice, {
          childList: true,
          subtree: true
        });
      }

      stickyAdd.addEventListener('click', () => {
        submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!submitBtn.disabled) submitBtn.click();
      });

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
            } else {
              bar.removeAttribute('hidden');
              bar.classList.add('is-visible');
            }
          });
        },
        { rootMargin: '0px', threshold: 0 }
      );
      observer.observe(submitBtn);
    });

    /* Partial-add cart drawer refresh.

       Dawn's product-form.js takes the error branch (response.status truthy)
       when the server returns 422 — most commonly the "Only N items were
       added to your cart due to availability" case. In that branch it
       publishes cartError, shows the error message, and RETURNS without
       calling cart.renderContents — so the items that did get added do not
       show up in the drawer until a page refresh.

       Fix: subscribe to cartError. When source === 'product-form', re-fetch
       the cart-drawer sections and feed them into the existing
       cartDrawer.renderContents pipeline. Same path Dawn uses on success,
       just triggered from the error branch. Pubsub.js is loaded globally
       (assets/pubsub.js included in theme.liquid layout). */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, function (payload) {
        if (!payload || payload.source !== 'product-form') return;
        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        var sectionIds = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        fetch('/?sections=' + sectionIds)
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            cartDrawer.renderContents({ sections: sections });
          })
          .catch(function (e) { console.error('Partial-add cart refresh failed:', e); });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funk-reviews"] && !Shopify.designMode) return;
  try {
    
  class FunkTrustCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.slides = Array.from(this.querySelectorAll('.funk-trust__slide'));
      this.tabs = Array.from(this.querySelectorAll('[data-funk-tab]'));
      if (this.slides.length < 2) return;

      this.interval = parseInt(this.dataset.interval || '4000', 10);
      this.active = 0;
      this._timeout = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      document.documentElement.style.setProperty('--funk-trust-rotate', this.interval + 'ms');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(index);
        });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.active + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.active - 1);
        }
      });

      this.active = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.active < 0) this.active = 0;
      this.syncTabProgress();

      if (!this.reduceMotion) this.scheduleNext();
    }

    syncTabProgress() {
      const tab = this.tabs[this.active];
      if (!tab) return;
      tab.classList.remove('is-active');
      void tab.offsetWidth;
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
    }

    goTo(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      if (index === this.active) {
        this.syncTabProgress();
        if (!this.reduceMotion) this.scheduleNext();
        return;
      }

      const previousSlide = this.slides[this.active];
      const previousTab = this.tabs[this.active];
      const nextSlide = this.slides[index];

      previousSlide.classList.remove('is-active');
      previousSlide.setAttribute('aria-hidden', 'true');
      if (previousTab) {
        previousTab.classList.remove('is-active');
        previousTab.setAttribute('aria-selected', 'false');
      }

      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');

      this.active = index;
      this.syncTabProgress();

      if (!this.reduceMotion) this.scheduleNext();
    }

    scheduleNext() {
      this.clearNext();
      this._timeout = window.setTimeout(() => {
        this.goTo(this.active + 1);
      }, this.interval);
    }

    clearNext() {
      if (this._timeout) {
        window.clearTimeout(this._timeout);
        this._timeout = null;
      }
    }

    disconnectedCallback() {
      this.clearNext();
    }
  }

  if (!customElements.get('funk-trust-carousel')) {
    customElements.define('funk-trust-carousel', FunkTrustCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.header.classList.contains('menu-open')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
